<template>
  <div class="container-fluid">
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing shadow-sm">
      <!-- En-tête de la carte -->
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        <div class="d-sm-flex align-items-center">
          <router-link
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            to="/ajouter/etape-1">
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            Ajouter un BESC
          </router-link>
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
            type="button" @click="exporterBescs">
            Exporter
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div>
        <div class="d-flex align-items-center">
          <form class="search-box position-relative me-15" @submit.prevent="rechercher">
            <input type="text" v-model="searchTerm" @input="rechercher"
              class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher un BESC" />
            <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
        </div>
      </div>
      <!-- Corps de la carte -->
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Référence BESC
                </th>
                <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Navire
                </th> -->
                <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  N° Connaissement
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Importateur
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  ETD
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  ETA
                </th> -->

                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Importateur
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Montant BESC
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Statut BESC
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Statut Paiement
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">
                  ACTIONS
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(besc, index) in bescs" :key="index">
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ besc.refbesc }}
                </td>
                <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ besc.vessel?.name || 'N/A' }}
                </td> -->
                <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ besc.numeroConnaissement }}
                </td> -->
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ getImportateur(besc)?.acteur.nomComplet || 'N/A' }}
                </td>
                <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ format_Date(besc.etd) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ format_Date(besc.eta) }}
                </td> -->
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  <span v-if="besc.facture">
                    {{ formatEuro(besc.facture.montantTotal) }}
                  </span>
                  <span v-else class="text-muted">Non calculé</span>
                </td>

                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  <span :class="getStatusClass(besc.currentStatus?.code)">
                    {{ getDisplayedStatusLabel(besc) }}
                  </span>
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  <span v-if="!besc.facture" class="badge bg-secondary">
                    Sans facture
                  </span>
                  <span v-else-if="Number(besc.facture.balanceDue) === 0" class="badge bg-success">
                    Payé
                  </span>
                  <span v-else-if="besc.facture.status === 'PARTIALLY_PAID'" class="badge bg-warning">
                    Partiel
                  </span>
                  <span v-else class="badge bg-warning text-black ">
                    En Attente ({{ formatEuro(besc.facture.balanceDue) }})
                  </span>
                </td>
                <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                  <div class="dropdown">
                    <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                      aria-expanded="false" style="cursor: pointer;">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                    </span>
                    <ul class="dropdown-menu">
                      <li v-if="!checkRole('Transitaire')">
                      <router-link :to="{ name: 'ViewBesc', params: { id: besc.id } }"
                        class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                        Détails
                      </router-link>
                    </li>

                      <!-- POURSUIVRE LA CRÉATION (uniquement si aucune facture) -->
                      <li v-if="!besc.facture">
                        <a href="javascript:void(0);"
                          class="dropdown-item d-flex align-items-center text-primary fw-bold"
                          @click="poursuivreCreation(besc.id)">
                          <i class="flaticon-plus lh-1 me-8 position-relative top-1"></i>
                          Poursuivre la création de mon BESC
                        </a>
                      </li>
                      <!-- SOUMETTRE ET PAYER (uniquement si DRAFT ou SUBMITTED impayé) -->
                      <li v-if="shouldShowSubmitAndPayButton(besc)">
                        <a href="javascript:void(0);"
                          class="dropdown-item d-flex align-items-center text-success fw-bold"
                          :class="{ 'disabled': loadingValidation[besc.id] }" @click="submitAndPay(besc.id)">
                          <i v-if="loadingValidation[besc.id]" class="fa fa-spinner fa-spin lh-1 me-8"></i>
                          <i v-else class="flaticon-credit-card lh-1 me-8 position-relative top-1"></i>
                          {{ getSubmitButtonText(besc) }}
                        </a>
                      </li>
                      <!-- VOIR LA FACTURE (si existe) -->
                      <li v-if="besc.facture">
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"
                          @click="voirFacture(besc.facture.id, besc.id)">
                          <span v-if="loadingDownload[`facture_${besc.id}`]"
                            class="spinner-border spinner-border-sm me-8" role="status"></span>
                          <i v-else class="flaticon-file-invoice lh-1 me-8 position-relative top-1"></i>
                          {{ loadingDownload[`facture_${besc.id}`] ? 'Téléchargement...' : `Voir la facture
                          (${formatEuro(besc.facture?.montantTotal)})` }}
                        </a>
                      </li>

                      <li>
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"
                          @click="saveDraft(besc.id)">
                          <i class="flaticon-file-invoice lh-1 me-8 position-relative top-1"></i>
                          Actualiser la facture
                        </a>
                      </li>
                      <!-- HISTORIQUE PAIEMENT -->
                      <!-- <li v-if="besc.facture?.payments && besc.facture.payments.length > 0">
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"
                          @click="voirHistoriquePaiement(besc.facture.id)">
                          <i class="flaticon-receipt lh-1 me-8 position-relative top-1"></i>
                          Historique de paiement ({{ besc.facture.payments.length }})
                        </a>
                      </li> -->
                      <li>
                        <hr class="dropdown-divider">
                      </li>
                      <!-- MODIFIER (uniquement si pas de corrections demandées) -->
                      <li v-if="besc.currentStatus?.code === 'DRAFT'">
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"
                          @click="modifierBesc(besc.id)">
                          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                          Mettre à jour ce Besc
                        </a>
                      </li>
                      <!-- APPORTER DES CORRECTIONS (si corrections demandées) -->
                      <li v-if="besc.currentStatus?.code === 'PENDING_CORRECTION'">
                        <a href="javascript:void(0);"
                          class="dropdown-item d-flex align-items-center text-warning fw-bold"
                          @click="modifierBesc(besc.id)">
                          <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                          Apporter des corrections
                        </a>
                      </li>

                      <!-- TELECHARGER BROUILLON (uniquement DRAFT) -->
                      <li v-if="besc.currentStatus?.code === 'DRAFT'">
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"
                          :class="{ 'disabled opacity-50': loadingDownload[besc.id] }"
                          @click="telechargerBrouillon(besc.id)">
                          <span v-if="loadingDownload[besc.id]" class="spinner-border spinner-border-sm me-8"
                            role="status"></span>
                          <i v-else class="flaticon-file-1 lh-1 me-8 position-relative top-1"></i>
                          {{ loadingDownload[besc.id] ? 'Génération en cours...' : 'Télécharger brouillon' }}
                        </a>
                      </li>

                      <!-- TELECHARGER PDF (uniquement APPROVED) -->
                      <li v-if="besc.currentStatus?.code === 'APPROVED'">
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"
                          :class="{ 'disabled opacity-50': loadingDownload[`pdf_${besc.id}`] }"
                          @click="telechargerPDF(besc.id)">
                          <span v-if="loadingDownload[`pdf_${besc.id}`]" class="spinner-border spinner-border-sm me-8"
                            role="status"></span>
                          <i v-else class="flaticon-file-1 lh-1 me-8 position-relative top-1"></i>
                          {{ loadingDownload[`pdf_${besc.id}`] ? 'Génération en cours...' : 'Télécharger PDF' }}
                        </a>
                      </li>
                      <!-- TELECHARGER XML (uniquement APPROVED) -->
                      <li v-if="besc.currentStatus?.code === 'APPROVED'">
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"
                          @click="telechargerXML(besc.id)">
                          <i class="flaticon-code lh-1 me-8 position-relative top-1"></i>
                          Télécharger XML
                        </a>
                      </li>
                      <!-- SUPPRIMER (uniquement DRAFT) -->
                      <li v-if="besc.currentStatus?.code === 'DRAFT'">
                        <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center text-danger"
                          @click="supprimerBesc(besc.id, besc.refbesc)">
                          <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                          Supprimer
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr v-if="bescs.length === 0">
                <td colspan="10" class="text-center text-muted py-4">
                  Aucun BESC trouvé.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Pagination -->
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
            @paginate="handlePaginate" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, reactive } from "vue";
import Swal from "sweetalert2";
import ApiService from "@/services/ApiService";
import { error, success, format_Date } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { Besc } from "@/models/Besc";
import router from "@/router";

export default defineComponent({
  name: "ListeBesc",
  components: {
    PaginationComponent,
  },
  setup() {
    const bescs = ref<Array<Besc>>([]);
    const besc = ref<Besc>();
    const bescActeurs = ref<any[]>([]);
    const prepaidAccount = ref<any>(null);
    const showPaymentModal = ref(false);
    const selectedBesc = ref<any>(null);
    const selectedFacture = ref<any>(null);
    const loadingValidation = reactive<Record<string, boolean>>({});
    const loadingDownload = reactive<Record<string, boolean>>({});
    const addModalValidationCommentRef = ref<any>(null);
    const selectedBescId = ref<string>('');
    const roles = ref<Array<string>>(JwtService.getRole());


    // Pagination
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllBescs(page_, limit_);
      } catch (err) {
        error("Erreur lors de la pagination");
      }
    };

    function rechercher() {
      getAllBescs(page.value, limit.value, searchTerm.value);
    }

    const saveDraft = async (bescId) => {

      try {
        const response = await ApiService.post(`/besc/${bescId}/calculate-fees`, {})
        success('Facture téléchargée avec succès !');
      } catch (err: any) {
        error(err.response?.data?.message || 'Erreur lors de la finalisation du BESC')
      } finally {
        //submitting.value = false
      }
    }

    const checkRole = (name: string) => {
      return roles.value.includes(name);
    };

    function getAllBescs(page = 1, limi = 10, searchTerm = '') {
      console.log(' [GET_ALL_BESC] Chargement - page:', page, 'limit:', limi);

      return ApiService.get(`/bescs?page=${page}&limit=${limi}&mot=${searchTerm}`)
        .then(({ data }) => {
          console.log(' [GET_ALL_BESC] Données reçues:', {
            total: data.data.totalElements,
            bescsCount: data.data.data.length
          });

          bescs.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;

          // Log détaillé pour debug
          bescs.value.forEach((besc: any) => {
            console.log(' [GET_ALL_BESC] BESC chargé:', {
              ref: besc.refbesc,
              statut: besc.currentStatus?.code,
              facture: besc.facture ? {
                ref: besc.facture.referenceFacture,
                status: besc.facture.status,
                balanceDue: Number(besc.facture.balanceDue),
                montantTotal: Number(besc.facture.montantTotal)
              } : null
            });
          });

          return data.data;
        })
        .catch(({ response }) => {
          console.error(' [GET_ALL_BESC] Erreur:', response);
          error(response?.data?.message || "Erreur lors du chargement des BESCs");
        });
    }

    const getImportateur = (besc) => {
      if (!besc?.bescActeurs) return null;
      return besc.bescActeurs.find(a => a.acteur.typeActeur.libelle === "Importateur");
    };

    const formatEuro = (val: any) => {
      if (val == null || val === undefined) return '— €';

      const num = Number(val);
      if (isNaN(num)) return '— €';

      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    };

    // const getStatusClass = (code: string) => {
    //   switch (code) {
    //     case 'DRAFT':
    //       return 'badge bg-secondary';
    //     case 'SUBMITTED':
    //       return 'badge bg-warning text-dark';
    //     case 'APPROVED':
    //       return 'badge bg-success';
    //     case 'REJECTED':
    //       return 'badge bg-danger';
    //     case 'ISSUED':
    //       return 'badge bg-primary';
    //     case 'PENDING_CORRECTION':
    //       return 'badge bg-info';
    //     case 'UNDER_REVIEW':
    //       return 'badge bg-warning text-dark';
    //     default:
    //       return 'badge bg-secondary';
    //   }
    // };

    const getStatusClass = (code: string) => {
      switch (code) {

        case 'DRAFT':
          return 'badge bg-secondary';

        case 'SUBMITTED':
          return 'badge bg-warning text-dark';

        case 'CORRECTIONS_IN_PROGRESS':
          return 'badge bg-info';

        case 'CORRECTIONS_COMPLETED':
          return 'badge bg-primary';

        case 'APPROVED':
          return 'badge bg-success';

        case 'ISSUED':
          return 'badge bg-primary';

        case 'REJECTED':
          return 'badge bg-danger';

        case 'CANCELLED':
          return 'badge bg-dark';

        default:
          return 'badge bg-secondary';
      }
    };


    // NOUVEAU : Affichage clair du statut pour l'utilisateur
    // const getDisplayedStatusLabel = (besc: any) => {
    //   const baseLabel = besc.currentStatus?.label || 'Inconnu';
    //   const facture = besc.facture;
    //   const isPaid = facture && Number(facture.balanceDue) === 0;

    //   if (besc.currentStatus?.code === 'SUBMITTED' && isPaid) {
    //     return besc.currentStatus?.label;
    //   }
    //   return baseLabel;
    // };

    const getDisplayedStatusLabel = (besc: any) => {
      return besc.currentStatus?.label || 'Inconnu';
    };

    const shouldShowSubmitAndPayButton = (besc: any) => {
      const status = besc.currentStatus?.code;
      const facture = besc.facture;

      // Affiché si DRAFT ou si SUBMITTED mais pas encore entièrement payé
      return (
        status === 'DRAFT' ||
        (status === 'SUBMITTED' && facture && Number(facture.balanceDue) > 0)
      );
    };

    const getSubmitButtonText = (besc: any) => {
      const facture = besc.facture;
      const status = besc.currentStatus?.code;

      if (status === 'DRAFT') {
        return 'En attente';
      }
      if (status === 'SUBMITTED' && facture && Number(facture.balanceDue) > 0) {
        return `Payer le restant (${formatEuro(facture.balanceDue)})`;
      }
      return 'Payer';
    };

    const submitAndPay = async (bescId: string) => {
      await demanderValidation(bescId);
    };

    const modifierBesc = (id: string) => {
      router.push({
        name: "EditAddBescStep1",
        params: { id }
      });
    };



    const poursuivreCreation = async (id: string) => {
      console.log('poursuivreCreation appelée avec ID:', id);
      try {
        // Charger la progression du BESC depuis l'API
        const { loadBescProgressionFromAPI, getNextStep, bescWizard } = await import('@/utils/bescWizard');

        // Définir l'ID du BESC dans le wizard
        bescWizard.bescId = id;

        // Charger la progression
        await loadBescProgressionFromAPI(id);

        // Charger et transformer les données exactement comme dans EditAddBescStep1
        const response = await ApiService.get(`/besc/${id}`);
        const donnees = response.data.data;

        console.log('Données BESC récupérées:', donnees);

        // Récupérer les IDs directement depuis les champs du BESC (au cas où)
        if (donnees.importateur) bescWizard.step1.importateur = donnees.importateur;
        if (donnees.partieANotifier) bescWizard.step1.partieANotifier = donnees.partieANotifier;
        if (donnees.transitaire) bescWizard.step1.transitaire = donnees.transitaire;
        if (donnees.expediteur) bescWizard.step1.expediteur = donnees.expediteur;
        if (donnees.transporteur) bescWizard.step1.transporteur = donnees.transporteur;

        // Transformer les données comme dans getBescStep1
        if (donnees.bescActeurs && Array.isArray(donnees.bescActeurs)) {
          console.log('bescActeurs trouvés:', donnees.bescActeurs.length, 'acteurs');
          donnees.bescActeurs.forEach((item: any) => {
            const acteur = item.acteur;
            if (!acteur || !acteur.typeActeur) return;

            const role = acteur.typeActeur.libelle.toLowerCase();
            console.log('👤 Acteur:', acteur.nomComplet, '| Rôle:', role);

            if (role.includes('importateur')) {
              bescWizard.step1.importateur = acteur.id;
              console.log('Importateur assigné:', acteur.id);
            }
            if (role.includes('partie à notifier')) {
              bescWizard.step1.partieANotifier = acteur.id;
              console.log('Partie à notifier assignée:', acteur.id);
            }
            if (role.includes('transitaire')) {
              bescWizard.step1.transitaire = acteur.id;
              console.log('Transitaire assigné:', acteur.id);
            }
            if (role.includes('expediteur')) {
              bescWizard.step1.expediteur = acteur.id;
              console.log('Expéditeur assigné:', acteur.id);
            }
            if (role.includes('transporteur')) {
              bescWizard.step1.transporteur = acteur.id;
              console.log('Transporteur assigné:', acteur.id);
              if (donnees.transbordement?.toLowerCase() === 'oui') {
                bescWizard.step1.transporteurApresTransbordement = acteur.id;
                console.log('Transporteur après transbordement assigné:', acteur.id);
              }
            }
          });
        } else {
          console.log('Aucun bescActeurs trouvé ou pas un tableau');
        }

        // Charger les autres données
        bescWizard.step1.numeroConnaissement = donnees.numeroConnaissement || '';
        bescWizard.step1.etd = donnees.etd ? donnees.etd.split('T')[0] : '';
        bescWizard.step1.eta = donnees.eta ? donnees.eta.split('T')[0] : '';
        bescWizard.step1.incoterm = donnees.incoterm?.id || null;
        bescWizard.step1.paysOrigine = donnees.paysOrigine?.id || null;
        bescWizard.step1.typeFret = donnees.typeFret?.id || null;
        bescWizard.step1.vessel = donnees.vessel?.id || null;
        bescWizard.step1.portChargement = donnees.portChargement?.id || null;
        bescWizard.step1.portDechargement = donnees.portDechargement?.id || null;
        bescWizard.step1.destinationFinale = donnees.destinationFinalePays?.id || null;
        bescWizard.step1.transbordement = donnees.transbordement?.toLowerCase() === 'oui' ? 'oui' : 'non';
        bescWizard.step1.navireApresTransbordement = donnees.navireApresTransbordement?.id || null;

        console.log('Données finales dans bescWizard.step1:', bescWizard.step1);

        // Stocker les acteurs spécifiques
        if (donnees.bescActeurs && Array.isArray(donnees.bescActeurs)) {
          const acteursSpecifiques = donnees.bescActeurs.map((item: any) => {
            const acteur = item.acteur;
            return {
              label: acteur.nomComplet,
              value: acteur.id,
              typeId: acteur.typeActeur?.id,
              typeLibelle: acteur.typeActeur?.libelle,
              role: acteur.typeActeur?.libelle.toLowerCase()
            };
          });

          sessionStorage.setItem('besc_acteurs_specifiques', JSON.stringify(acteursSpecifiques));
          console.log(' Acteurs spécifiques sauvegardés:', acteursSpecifiques);
        }

        const naviresEtPorts: any = {};

        if (donnees.vessel) {
          naviresEtPorts.vessel = {
            label: `${donnees.vessel.name} - ${donnees.vessel.mmsi || 'N/A'} - ${donnees.vessel.imo || 'N/A'}`,
            value: donnees.vessel.id
          };
          console.log('Navire principal sauvegardé:', naviresEtPorts.vessel.label);
        }

        if (donnees.navireApresTransbordement) {
          naviresEtPorts.navireApresTransbordement = {
            label: `${donnees.navireApresTransbordement.name} - ${donnees.navireApresTransbordement.mmsi || 'N/A'} - ${donnees.navireApresTransbordement.imo || 'N/A'}`,
            value: donnees.navireApresTransbordement.id
          };
          console.log('Navire après transbordement sauvegardé:', naviresEtPorts.navireApresTransbordement.label);
        }

        if (donnees.portChargement) {
          naviresEtPorts.portChargement = {
            label: `${donnees.portChargement.nomPort} - ${donnees.portChargement.locode || 'N/A'}`,
            value: donnees.portChargement.id,
            codePays: donnees.portChargement.codePays || ''
          };
          console.log(' Port de chargement sauvegardé:', naviresEtPorts.portChargement.label);
        }

        if (donnees.portDechargement) {
          naviresEtPorts.portDechargement = {
            label: `${donnees.portDechargement.nomPort} - ${donnees.portDechargement.locode || 'N/A'}`,
            value: donnees.portDechargement.id,
            codePays: donnees.portDechargement.codePays || ''
          };
          console.log('Port de déchargement sauvegardé:', naviresEtPorts.portDechargement.label);
        }

        sessionStorage.setItem('besc_navires_ports', JSON.stringify(naviresEtPorts));
        console.log('Navires et ports sauvegardés dans sessionStorage');

        try {
          const blsResponse = await ApiService.get(`/besc/${id}/bls`);
          console.log('Réponse complète BLs:', blsResponse.data);

          if (blsResponse.data.data && blsResponse.data.data.length > 0) {
            console.log('Chargement des BLs pour étape 2...');
            console.log('BLs actuels dans bescWizard AVANT vidage:', bescWizard.step2.listeBLs.length);

            bescWizard.step2.listeBLs.splice(0, bescWizard.step2.listeBLs.length);
            console.log('BLs après vidage:', bescWizard.step2.listeBLs.length);

            const compagniesOptions: any[] = [];
            const naviresOptions: any[] = [];

            for (const bl of blsResponse.data.data) {
              console.log('BL brut:', bl);
              console.log('marchandises du BL:', bl.marchandises);

              const blData: any = {
                id: bl.id,
                numeroBL: bl.bl_number || bl.numeroBL,
                idCompagnie: bl.shipping_line_id || bl.idCompagnie,
                idNavire: bl.ship_id || bl.idNavire,
                referenceVoyage: bl.voyage_reference || bl.referenceVoyage || '',
                poidsBrut: parseFloat(bl.gross_weight || bl.poidsBrut || 0),
                marchandises: [],
                erreurs: {}
              };

              if (bl.compagnie) {
                compagniesOptions.push({
                  label: `${bl.compagnie.name} ${bl.compagnie.scac_code ? `- ${bl.compagnie.scac_code}` : ''}`,
                  value: bl.compagnie.id
                });
                console.log('Compagnie chargée:', bl.compagnie.name);
              }

              if (bl.navire) {
                naviresOptions.push({
                  label: `${bl.navire.name} - MMSI: ${bl.navire.mmsi || 'N/A'} - IMO: ${bl.navire.imo || 'N/A'}`,
                  value: bl.navire.id
                });
                console.log('Navire chargé:', bl.navire.name);
              }

              if (bl.marchandises && bl.marchandises.length > 0) {
                blData.marchandises = bl.marchandises.map((m: any) => ({
                  id: m.id,
                  description: m.description,
                  hscode: m.hscode?.id || m.hscode,
                  nombreColis: parseInt(m.nombreColis || 1),
                  typeConditionnement: m.typeConditionnement,
                  poidsBrut: parseFloat(m.poidsBrut || 0),
                  poidsNet: parseFloat(m.poidsNet || 0),
                  volume: parseFloat(m.volume || 0),
                  valeurDeclaree: parseFloat(m.valeurDeclaree || 0),
                  devise: m.devise || 'USD',
                  paysOrigine: m.paysOrigine?.id || m.paysOrigine,
                  tableauIMDG: m.tableauIMDG?.id || m.tableauIMDG,
                  categorieProduit: m.categorieProduit?.id || m.categorieProduit,
                  conteneur: m.conteneur ? {
                    id: m.conteneur.id,
                    numeroConteneur: m.conteneur.numeroConteneur,
                    numeroScelle: m.conteneur.numeroScelle,
                    typeConteneur: m.conteneur.typeConteneur,
                    typeChargement: m.conteneur.typeChargement,
                    poidsBrut: parseFloat(m.conteneur.poidsBrut || 0),
                    volume: parseFloat(m.conteneur.volume || 0),
                    description: m.conteneur.description
                  } : null
                }));
                console.log(`${blData.marchandises.length} marchandise(s) chargée(s) pour BL ${blData.numeroBL}`);
              } else {
                console.log(`Aucune marchandise pour BL ${blData.numeroBL}`);
              }

              bescWizard.step2.listeBLs.push(blData);
            }

            const blsUniques = bescWizard.step2.listeBLs.filter((bl, index, self) =>
              index === self.findIndex((b) => b.id === bl.id)
            );

            if (blsUniques.length !== bescWizard.step2.listeBLs.length) {
              console.warn(`${bescWizard.step2.listeBLs.length - blsUniques.length} BL(s) en double détecté(s) et supprimé(s)`);
              bescWizard.step2.listeBLs.splice(0, bescWizard.step2.listeBLs.length);
              bescWizard.step2.listeBLs.push(...blsUniques);
            }

            // Stocker les options dans sessionStorage
            if (compagniesOptions.length > 0) {
              sessionStorage.setItem('besc_compagnies_options', JSON.stringify(compagniesOptions));
              console.log('Options compagnies sauvegardées:', compagniesOptions);
            }
            if (naviresOptions.length > 0) {
              sessionStorage.setItem('besc_navires_options', JSON.stringify(naviresOptions));
              console.log('Options navires sauvegardées:', naviresOptions);
            }

            sessionStorage.setItem('besc_step2_loaded', 'true');
            console.log('Étape 2 chargée:', bescWizard.step2.listeBLs.length, 'BL(s)');
            console.log('Flag step2_loaded activé dans sessionStorage');
          }
        } catch (err) {
          console.error('Erreur chargement BLs:', err);
        }

        // Déterminer la prochaine étape
        const nextStepRoute = getNextStep();
        console.log('Prochaine étape déterminée:', nextStepRoute);

        if (nextStepRoute) {
          // Rediriger vers la prochaine étape
          console.log('Redirection vers:', nextStepRoute, 'avec ID:', id);
          router.push({
            name: nextStepRoute,
            params: { id }
          });
        } else {
          // Si toutes les étapes sont complétées, aller au récapitulatif
          console.log('Redirection vers récapitulatif avec ID:', id);
          router.push({
            name: "Recapitulatif",
            params: { id }
          });
        }
      } catch (error) {
        console.error('Erreur dans poursuivreCreation:', error);
        console.error('Erreur lors de la détermination de l\'étape suivante:', error);
        // En cas d'erreur, rediriger vers l'étape 1 par défaut
        router.push({
          name: "EditAddBescStep1",
          params: { id }
        });
      }
    };

    const voirFacture = async (factureId: string, bescId: string) => {
      const key = `facture_${bescId}`
      if (loadingDownload[key]) return
      loadingDownload[key] = true
      try {
        const response = await ApiService.getFile(`/facture/${factureId}/pdf`)
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Facture_${factureId}.pdf`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setTimeout(() => window.URL.revokeObjectURL(url), 100)
        success('Facture téléchargée avec succès !')
      } catch (err: any) {
        error(err.response?.data?.message || 'Impossible de télécharger la facture.')
      } finally {
        loadingDownload[key] = false
      }
    };

    const loadPrepaidAccount = async () => {
      try {
        const userStr = localStorage.getItem('user');
        if (!userStr) return;
        const user = JSON.parse(userStr);
        if (!user.acteurId) return;

        const res = await ApiService.get(`/prepaid-accounts/acteur/${user.acteurId}`);

        if (res.data.data) {
          const accounts = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
          const activeAccount = accounts.find((acc: any) =>
            acc.status === 'ACTIVE' && Number(acc.balance) > 0
          );
          if (activeAccount) prepaidAccount.value = activeAccount;
        }
      } catch (err: any) {
        if (err.response?.status !== 404) console.error('Erreur compte prépayé:', err);
      }
    };

    const payerFacture = async (bescId: string, facture: any) => {
      try {
        await loadPrepaidAccount();

        selectedBesc.value = { id: bescId };
        selectedFacture.value = facture;

        const montantAffiche = Number(facture.balanceDue) || Number(facture.montantTotal) || 0;

        await Swal.fire({
          title: '',
          html: `
        <style>
          .payment-modal-container {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          }
          .payment-header {
            background: linear-gradient(135deg, #0a59a4 0%, #0d6ec9 100%);
            color: white;
            padding: 2rem;
            border-radius: 16px 16px 0 0;
            margin: -1.5rem -1.5rem 2rem -1.5rem;
            text-align: center;
          }
          .amount-display {
            background: rgba(255,255,255,0.15);
            padding: 1rem;
            border-radius: 12px;
            margin: 1rem 0;
            color: white;
            font-size: 1.8rem;
            font-weight: 700;
          }
          .payment-methods-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 1.5rem;
            padding: 0 1rem;
          }
          .payment-method-card {
            position: relative;
            background: white;
            border: 2px solid #e2e8f0;
            border-radius: 16px;
            padding: 2rem 1.5rem;
            cursor: pointer;
            text-align: center;
            transition: all 0.3s ease;
          }
          .payment-method-card:hover {
            transform: translateY(-8px);
            border-color: #0a59a4;
            box-shadow: 0 20px 40px rgba(10, 89, 164, 0.15);
          }
          .payment-method-card.recommended::before {
            content: '⭐ Recommandé';
            position: absolute;
            top: -12px;
            left: 50%;
            transform: translateX(-50%);
            background: linear-gradient(135deg, #10b981, #059669);
            color: white;
            padding: 0.35rem 1rem;
            border-radius: 20px;
            font-size: 0.75rem;
          }
        </style>
       
        <div class="payment-modal-container">
          <div class="payment-header">
            <h2> Finaliser le paiement</h2>
            <p>Paiement sécurisé</p>
            <div class="amount-display">
              ${formatEuro(montantAffiche)}
            </div>
          </div>
         
          ${prepaidAccount.value ? `
            <div class="alert alert-success mb-4">
              <strong> Solde disponible :</strong>
              ${formatEuro(prepaidAccount.value.balance)}
            </div>
          ` : ''}
         
          <div class="payment-methods-grid">
            ${prepaidAccount.value && Number(prepaidAccount.value.balance) >= montantAffiche ? `
              <div class="payment-method-card recommended" data-method="prepaid">
                <div style="font-size: 3rem; margin-bottom: 1rem;"></div>
                <div style="font-weight: 700; font-size: 1.1rem;">Compte Prépayé</div>
                <div style="font-size: 0.875rem; color: #64748b;">
                 Solde : ${formatEuro(prepaidAccount.value.balance)}
                </div>
              </div>
            ` : ''}
           
            <div class="payment-method-card recommended" data-method="kkiapay">
              <img src="/kkiapay.png.webp" alt="KkiaPay"
                style="width: 60px; height: 60px; object-fit: contain;"/>
              <div style="font-weight: 700; margin-top: 1rem;">KkiaPay</div>
              <div style="font-size: 0.875rem; color: #64748b;">MTN • Moov</div>
            </div>
           
            <div class="payment-method-card" data-method="paypal">
              <img src="/paypal.png.png" alt="PayPal"
                style="width: 60px; height: 60px; object-fit: contain;"/>
              <div style="font-weight: 700; margin-top: 1rem;">PayPal</div>
            </div>
           
            <div class="payment-method-card" data-method="stripe">
              <img src="/stripe.png.png" alt="Stripe"
                style="width: 60px; height: 60px; object-fit: contain;"/>
              <div style="font-weight: 700; margin-top: 1rem;">Carte Bancaire</div>
            </div>
          </div>
         
          ${prepaidAccount.value && Number(prepaidAccount.value.balance) < montantAffiche ? `
            <div class="alert alert-warning mt-4">
               Solde insuffisant. Manquant :
              ${formatEuro(montantAffiche - Number(prepaidAccount.value.balance))}
            </div>
          ` : ''}
        </div>
      `,
          showConfirmButton: false,
          showCloseButton: true,
          width: '850px',
          didOpen: () => {
            document.querySelectorAll('.payment-method-card').forEach(btn => {
              btn.addEventListener('click', async (e) => {
                const method = (e.currentTarget as HTMLElement).getAttribute('data-method');
                Swal.close();
                if (method === 'prepaid') {
                  await payWithPrepaidAccount(bescId, facture.id);
                  return;
                }
                await initiatePayment(bescId, method as any, '');
              });
            });
          }
        });
      } catch (err: any) {
        console.error(' Erreur payerFacture:', err);
        error(err.response?.data?.message || 'Erreur lors du paiement');
      }
    };

    const voirHistoriquePaiement = async (factureId: string) => {
      try {
        const response = await ApiService.get(`/payments/facture/${factureId}`);
        const data = response.data.data;

        if (!data.payments || data.payments.length === 0) {
          await Swal.fire({
            icon: 'info',
            title: 'Aucun paiement',
            text: 'Aucun historique de paiement disponible pour cette facture'
          });
          return;
        }

        const paymentsHtml = data.payments.map((payment: any) => `
          <tr>
            <td class="text-start">${new Date(payment.paidAt).toLocaleDateString('fr-FR')}</td>
            <td class="text-end">${formatEuro(payment.amount)}</td>
            <td class="text-center">
              <span class="badge bg-${payment.status === 'CONFIRMED' ? 'success' : 'warning'}">
                ${payment.status === 'CONFIRMED' ? 'Confirmé' : payment.status}
              </span>
            </td>
            <td class="text-center">${payment.paymentMethodType || 'N/A'}</td>
          </tr>
        `).join('');

        await Swal.fire({
          title: ' Historique des paiements',
          html: `
            <div class="table-responsive">
              <table class="table table-striped table-sm">
                <thead>
                  <tr>
                    <th class="text-start">Date</th>
                    <th class="text-end">Montant</th>
                    <th class="text-center">Statut</th>
                    <th class="text-center">Méthode</th>
                  </tr>
                </thead>
                <tbody>
                  ${paymentsHtml}
                </tbody>
                <tfoot>
                  <tr class="fw-bold">
                    <td class="text-start">Total payé</td>
                    <td class="text-end">${formatEuro(data.totalPaid)}</td>
                    <td colspan="2"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          `,
          width: '700px',
          confirmButtonText: 'Fermer'
        });

      } catch (err: any) {
        console.error(' Erreur historique paiements:', err);
        error('Impossible de charger l\'historique des paiements');
      }
    };

    const demanderValidation = async (id: string) => {
      try {
        loadingValidation[id] = true;

        console.log(' Action demandée pour BESC:', id);

        const { data: bescData } = await ApiService.get(`/besc/${id}`);
        const besc = bescData.data;

        console.log(' État BESC:', {
          ref: besc.refbesc,
          statut: besc.currentStatus?.code,
          facture: besc.facture ? {
            status: besc.facture.status,
            balanceDue: Number(besc.facture.balanceDue)
          } : 'Aucune'
        });

        // Ouvrir directement le modal de paiement
        if (besc.facture && Number(besc.facture.balanceDue) > 0) {
          await payerFacture(id, besc.facture);
        } else {
          await Swal.fire({
            icon: 'info',
            title: ' Information',
            text: 'Ce dossier n\'a pas de facture impayée',
            confirmButtonText: 'OK'
          });
        }

      } catch (err: any) {
        console.error(' Erreur demanderValidation:', err);
        error(err.response?.data?.message || 'Une erreur est survenue');
      } finally {
        delete loadingValidation[id];
      }
    };

    const payWithPrepaidAccount = async (bescId: string, factureId: string) => {
      try {
        console.log(' Paiement par compte prépayé - BESC:', bescId, 'Facture:', factureId);

        const response = await ApiService.post(`/payments/prepaid`, {
          factureId: factureId,
          acteurId: prepaidAccount.value.acteurId,
          amount: selectedFacture.value.montantTotal,
          paymentMethodType: 'PREPAID_ACCOUNT',
          comment: 'Paiement via compte prépayé'
        });

        console.log(' Réponse paiement:', response.data);

        success(' Paiement effectué avec succès ! Votre dossier est en attente de validation.');

        // Recharger avec délai pour laisser le backend traiter
        await new Promise(resolve => setTimeout(resolve, 1000));
        await getAllBescs(page.value, limit.value, searchTerm.value);

      } catch (err: any) {
        console.error(' Erreur paiement prépayé:', err);
        error(err.response?.data?.message || 'Erreur lors du paiement');
      }
    };

    const initiatePayment = async (bescId: string, method: 'kkiapay' | 'paypal' | 'stripe', comment?: string) => {
      try {
        loadingValidation[bescId] = true;

        await loadPrepaidAccount();

        if (comment) {
          sessionStorage.setItem(`besc_${bescId}_comment`, comment);
        }

        if (method === 'paypal') {
          const { data } = await ApiService.post(`/besc/${bescId}/payment/paypal/create-order`, {
            comment: comment || null
          });

          sessionStorage.setItem('pendingPaymentBescId', bescId);
          window.location.href = data.data.approvalUrl;
          return;
        }

        if (method === 'stripe') {
          sessionStorage.setItem('pendingPaymentBescId', bescId);
          router.push(`/paiement-stripe/${bescId}`);
          return;
        }

        if (method === 'kkiapay') {
          sessionStorage.setItem('pendingPaymentBescId', bescId);
          router.push(`/paiement-kkiapay/${bescId}`);
          return;
        }

      } catch (err: any) {
        console.error(' Erreur paiement:', err);
        error(err.response?.data?.message || 'Impossible de lancer le paiement');
      } finally {
        delete loadingValidation[bescId];
      }
    };

    const telechargerBrouillon = async (id: number) => {
      if (loadingDownload[id]) return;

      loadingDownload[id] = true;

      try {
        const response = await ApiService.getFile(`/besc/${id}/download-draft`);

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `BESC_Brouillon_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          link.remove();
          window.URL.revokeObjectURL(url);
        }, 100);

        success('Brouillon téléchargé avec succès !');

      } catch (err: any) {
        console.error('Erreur téléchargement:', err);
        error(err.response?.data?.message || "Erreur lors du téléchargement du brouillon");
      } finally {
        loadingDownload[id] = false;
      }
    };

    const telechargerPDF = async (id: number) => {
      const key = `pdf_${id}`
      if (loadingDownload[key]) return
      loadingDownload[key] = true
      try {
        const response = await ApiService.getFile(`/besc/${id}/download-pdf`)
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `BESC_${id}.pdf`)
        document.body.appendChild(link)
        link.click()
        setTimeout(() => { link.remove(); window.URL.revokeObjectURL(url) }, 100)
        success('PDF téléchargé avec succès !')
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du téléchargement du PDF")
      } finally {
        loadingDownload[key] = false
      }
    };

    const telechargerXML = async (id: number) => {
      if (loadingDownload[id]) return;

      loadingDownload[id] = true;

      try {
        const response = await ApiService.getFile(`/besc/${id}/download-xml`);

        const blob = new Blob([response.data], { type: 'application/xml' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `BESC_${id}.xml`);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          link.remove();
          window.URL.revokeObjectURL(url);
        }, 100);

        success('XML téléchargé avec succès !');

      } catch (err: any) {
        console.error('Erreur téléchargement XML:', err);
        error(err.response?.data?.message || "Erreur lors du téléchargement du XML");
      } finally {
        loadingDownload[id] = false;
      }
    };

    const supprimerBesc = async (id: string, refbesc: string) => {
      const result = await Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: `Voulez-vous vraiment supprimer le BESC ${refbesc} ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Oui, supprimer',
        cancelButtonText: 'Annuler'
      });

      if (result.isConfirmed) {
        try {
          await ApiService.delete(`/besc/${id}`);
          success('BESC supprimé avec succès !');
          await getAllBescs(page.value, limit.value, searchTerm.value);
        } catch (err: any) {
          error(err.response?.data?.message || 'Erreur lors de la suppression');
        }
      }
    };

    const exporterBescs = () => {
      Swal.fire({
        title: 'Export',
        text: 'Fonctionnalité d\'export à venir',
        icon: 'info',
        heightAuto: false
      });
    };


    onMounted(async () => {
      console.log(' [MOUNTED] Initialisation ListeBesc');
      await getAllBescs();

      const pendingBescId = sessionStorage.getItem('pendingPaymentBescId');
      if (pendingBescId) {
        console.log(' [MOUNTED] Retour de paiement détecté pour BESC:', pendingBescId);
        sessionStorage.removeItem('pendingPaymentBescId');

        Swal.fire({
          title: ' Vérification du paiement...',
          html: 'Mise à jour du statut en cours...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        await new Promise(resolve => setTimeout(resolve, 3000));
        await getAllBescs(page.value, limit.value, searchTerm.value);

        Swal.close();

        try {
          const { data } = await ApiService.get(`/besc/${pendingBescId}`);
          const besc = data.data;
          if (besc.facture && Number(besc.facture.balanceDue) === 0) {
            success(' Paiement confirmé ! Votre dossier est en attente de validation.');
          }
        } catch (err) {
          console.error(' Erreur vérification statut:', err);
        }
      }
    });

    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    return {
      bescs,
      checkPermission,
      getAllBescs,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      format_Date,
      formatEuro,
      getStatusClass,
      getDisplayedStatusLabel,
      shouldShowSubmitAndPayButton,
      getSubmitButtonText,
      submitAndPay,
      modifierBesc,
      poursuivreCreation,
      telechargerBrouillon,
      telechargerPDF,
      telechargerXML,
      supprimerBesc,
      exporterBescs,
      loadingValidation,
      loadingDownload,
      getImportateur,
      addModalValidationCommentRef,
      selectedBescId,
      voirFacture,
      voirHistoriquePaiement,
      payerFacture,
      payWithPrepaidAccount,
      initiatePayment,
      prepaidAccount,
      selectedBesc,
      selectedFacture,
      saveDraft,
      checkRole
    };
  },
});
</script>

<style scoped>
.btn-payment-method {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px 24px;
  width: 180px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.btn-payment-method:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.18);
  border-color: #4f46e5;
}

.btn-payment-method img {
  transition: transform 0.3s ease;
}

.btn-payment-method:hover img {
  transform: scale(1.1);
}

.dropdown-divider {
  margin: 0.5rem 0;
}

.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.text-success.fw-bold {
  font-weight: 700 !important;
}
</style>